import React from "react"
import styled from "styled-components"

const Label = styled.label`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  width: 100%;
  input:active,
  input:focus {
    border-bottom: 2px solid #11adf3;
    ::placeholder {
      color: #ccc !important;
    }

    :-ms-input-placeholder {
      color: #ccc !important;
    }

    ::-ms-input-placeholder {
      color: #ccc !important;
    }
    & ~ span {
      /* //font-size: 14px; */
      bottom: 45px;
    }
  }

  ${props => props.isFilled
    && `
      span {
        /* //font-size: 14px; */
        bottom: 45px;
      }
    `}
`

const Span = styled.span`
  transition-duration: 0.2s;
  pointer-events: none;
  /* position: absolute;
  bottom: 45px; */
  left: 0px;
  width: 100%;
  user-select: none;
  color: #d4d4d4;
  font-weight: 400;
  text-transform: uppercase;
`

const Textarea = styled.textarea`
  flex: 1;
  font-size: 16px;
  background: transparent;
  outline: none;
  padding: 5px 0px;
  border-radius: 4px;
  border: 1px solid ${props => props.isError ? "#ff4b4b !important" : "#d4d4d4"};
  transition-duration: 0.2s;
  padding: 10px;
  height: ${props => props.height};
  background: #F9F8FF;

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #ccc !important;
    font-weight: 300;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #ccc !important;
    font-weight: 300;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #ccc !important;
    font-weight: 300;
  }
`

const ErrorLabel = styled.span`
  color: #ff4b4b;
`

const CharLimitText = styled.h6`
  font-color: #ddd;
  font-size: 12px;

  ${props => props.isExceeded
    && `
      color: red;
    `}
`

const Input = (field) => {
  const {
    label,
    input: { value = "" },
    charLimit,
    placeholder,
    cols,
    height,
    rows,
    version,
    customStyle,
  } = field
  return (
    <Label isFilled={value}>
      {version === 2 && (
        <Span>{label}</Span>
      )}
      <Textarea
        style={{
          ...customStyle || {},
        }}
        placeholder={placeholder}
        height={height}
        cols={cols}
        rows={rows}
        isError={!!(field.meta.touched && field.meta.error)}
        {...field.input}
      />
      {version !== 2 && (
        <Span>{label}</Span>
      )}
      {field.meta.touched && field.meta.error && <ErrorLabel>{field.meta.error}</ErrorLabel>}
      {charLimit && (
        <CharLimitText isExceeded={value.length > charLimit}>
          {`${value.length}/${charLimit} character count`}
        </CharLimitText>
      )}
    </Label>
  )
}

Input.defaultProps = {
  height: "200px",
  version: 2
}

export default Input
